import { defineTokens } from '@chakra-ui/react/styled-system';

export const fonts = defineTokens.fonts({
	heading: { value: '"Open Sans", sans-serif' },
	body: { value: '"Open Sans", sans-serif' }
});